// src/modules/restaurant/pages/respayment/components/TotalAmountCard.tsx
import React from "react";
import GroupIcon from "@mui/icons-material/Group";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { Order } from "src/shared/services/interfacev2";
import { splitDateTime } from "src/shared/components/dateTime";
import { useFormatAmount } from "src/business-types/laundry/modules/home/hooks/useFormatAmount";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

interface Props {
  order: Order | null;
  guess: number;
  getBgClass: () => string;
  isCompleted: boolean;
  finalAmount: string;
}

const TotalAmountCard: React.FC<Props> = ({ order, guess, getBgClass, isCompleted, finalAmount }) => {
  const { date: orderDate, time: orderTime } = splitDateTime(order?.orders?.[0]?.orderedOn?.$date ?? "");
  const formatAmount = useFormatAmount();
  const isDelivery = order?.orderDetails[0].orderType === "Delivery";

  return (
    <div className={`relative overflow-hidden ${getBgClass()} text-white rounded-xl p-2 mb-2 shadow-lg`}>
      <div className="absolute top-0 right-0 w-24 h-24 bg-white/10 rounded-full -translate-y-8 translate-x-8"></div>
      <div className="absolute bottom-0 left-0 w-16 h-16 bg-white/5 rounded-full -translate-x-4 translate-y-4"></div>

      <div className="relative">
        {/* TOTAL */}
        <div className="flex items-center justify-between mb-2">
          <span className="text-xl font-bold tracking-wide">TOTAL : {formatAmount(finalAmount)}</span>

          {/* Guests Badge */}
          {/* Conditional Badge - Guest count for Dine In, "Delivery" text for Delivery */}
          {!isDelivery ? (
            <div className="flex items-center gap-1 bg-white/20 px-2 py-0.5 rounded-xl backdrop-blur-sm border border-white/30">
              <GroupIcon className="text-white text-sm" />
              <span className="text-xs font-semibold">
                {guess} Guest{guess !== 1 ? "s" : ""}
              </span>
            </div>
          ) : (
            <div className="flex items-center gap-1 bg-white/20 px-2 py-0.5 rounded-xl backdrop-blur-sm border border-white/30">
              <LocalShippingIcon className="text-white text-sm" />
              <span className="text-xs font-semibold">
                Delivery
              </span>
            </div>
          )}
        </div>

        {/* Date & Time */}
        <span className="flex items-center gap-1.5 font-medium text-sm">
          <ScheduleIcon className="text-sm" />
          {orderTime || "--"} | {orderDate || "--"}
        </span>
      </div>
    </div>
  );
};

export default TotalAmountCard;